import { HTMLFromRichText, PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_EQUITY_CALCULATOR = 'PrismicGenericTemplateDataBodyEquityCalc';

export interface GenericEquityCalculatorPrimary {
  calculator_heading?: TextFromRichText;
  help_text?: HTMLFromRichText;
  radio_tooltip_content?: HTMLFromRichText;
  result_body: TextFromRichText;
  result_heading?: TextFromRichText;
  disclaimer?: TextFromRichText;
  button_link?: PrismicLink;
  button_text?: TextFromRichText;
}

export interface GenericEquityCalculatorContent {
  __typename: typeof GENERIC_EQUITY_CALCULATOR;
  primary: GenericEquityCalculatorPrimary;
}
